import type { Guide } from '../types';

/**
 * S-25.10-04 — wyjątek od zakazu podwykonawcy akceptuje CS (scenariusz e2e 32; Odpowiedzi CS 20.10 pkt 7).
 * Wniosek tradera czeka przy DEMO/2026/10/Q02 (`scenario-state.mjs`).
 */
export const guide: Guide = {
  flagKey: 'subcontractorExceptionByCs',
  title: 'Wyjątek od zakazu podwykonawcy akceptuje CS',
  whatItDoes:
    'Wnioski traderów o wyjątek od reguły klienta przy publikacji na giełdzie — gdy klient zakazuje podwykonawców albo dopuszcza ich warunkowo — rozstrzyga CS i Team Leader CS. Jak dotąd mogą to też administratorzy i osoby z uprawnieniem nadanym imiennie. CS widzi listę „Wnioski o wyjątek” z licznikiem czekających i dostaje powiadomienia o nowych wnioskach. Zatwierdzony wniosek pozwala traderowi zlecić publikację.',
  audience: ['CS', 'Team Leader CS', 'Trade'],
  presentationItems: ['S-25.10-04'],
  steps: [
    {
      route: '/publication-exceptions',
      target: 'publication-exceptions-count',
      title: 'Licznik w menu',
      description: 'W grupie „Giełdy” przy „Wnioskach o wyjątek” licznik wniosków, które czekają na decyzję CS.',
      action: 'Rozwiń w menu grupę „Giełdy” i spójrz na „Wnioski o wyjątek”.',
      recorder: { account: 'cs', actions: [{ kind: 'clickButton', name: 'Giełdy' }] },
    },
    {
      route: '/publication-exceptions',
      target: 'publication-exceptions',
      mockupTestId: 'sal-akceptacje-zgoda',
      title: 'CS zatwierdza albo odrzuca wniosek',
      description:
        'Na liście wniosków CS zatwierdza wniosek (uwagi opcjonalne) albo odrzuca go z powodem. Decyzja trafia do historii zlecenia; własnych wniosków się nie rozstrzyga.',
      action: 'Przy wniosku kliknij „Zatwierdź” albo „Odrzuć”.',
      recorder: { account: 'cs' },
    },
  ],
};
